import { useMemo } from "react";

import FailureMatrix from "../FailureMatrix";
import buildFailureMatrixData from "../builders/buildFailureMatrixData";

export default function ComfortSection({
    confortoMonitor
}) {

    const matrixData = useMemo(
        () => buildFailureMatrixData(confortoMonitor),
        [confortoMonitor]
    );

    return (
        <FailureMatrix
            cars={[1, 2, 3, 4, 5, 6, 7, 8]}
            categoryLabel="Conforto"
            systems={[
                {
                    key: "ar",
                    label: "Ar condicionado"
                },
                {
                    key: "luz",
                    label: "Iluminação"
                },
                {
                    key: "midia",
                    label: "Multimídia"
                }
            ]}
            matrixData={matrixData}
        />
    );
}